module.exports = __webpack_public_path__ + "static/img/banner-perfil-home-500x750.a9016ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-perfil-home-500x750.jpg
// module id = SkGO
// module chunks = 47